import React from 'react';
import { Button, Modal, ModalBody, ModalHeader} from 'reactstrap';


const CancelBidPopUp = (props) => {

    return (
        <Modal
            isOpen={props.showCancelBid}
            toggle={props?.toggleThankYou}
            className='success-sub'
        // size='lg'
        >
            <ModalHeader className="succ-header" toggle={props?.toggleThankYou}></ModalHeader>
            <ModalBody className="succ-body">
                <div className='wrapper text-center'>
                    <div className='w-100'>
                        <img className="ml-auto mr-auto succ-img" src={props?.close} alt='close-icon'/>
                    </div>
                    <p className="text-1">This action will cancel all bids
                        against this application</p>
                    <p className='text-primary'>
                    Please confirm if you wish to proceed
                    </p>

                    <Button onClick={props?.HandleCancleBid} className='explore'>Confirm</Button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default CancelBidPopUp;
